// 算分（玩家反馈 2026-11-02：“玩家自己算不清楚”）：按竞赛规则第二条 12、13 算出这一副所有可能的结果，
// 以及按当前已出完的人推出“现在最可能”的那几种。纯函数，界面只负责显示（main.ts 的算分面板）。
import { partnerOf, teamOf } from './match.ts';
import type { Match } from './match.ts';

export interface Outcome {
  team: 0 | 1; // 拿上游的一方
  partnerPlace: 2 | 3 | 4; // 上游搭档的游数
  steps: number; // 升几级
  from: number; // 升级前级数
  to: number; // 升级后级数（封顶 A = 14）
  passA: boolean; // 这样结束就过 A、赢下这一轮
  possible: boolean; // 按当前已出完的人，这种结果还可能发生
}

export function outcomes(m: Match): Outcome[] {
  const r = m.round;
  const head = r.finished[0];
  const out: Outcome[] = [];
  for (const team of [0, 1] as const) {
    for (const partnerPlace of [2, 3, 4] as const) {
      const steps = m.rules.upgrade[partnerPlace];
      const from = m.teamLevel[team];
      const target = m.rules.target ?? 14;
      const playingOwnA = r.levelTeam === team && from === target;
      const passA = playingOwnA && m.rules.passA.allowedPartnerPlaces.includes(partnerPlace);
      let possible = true;
      if (head !== undefined) {
        if (teamOf(head) !== team) possible = false;
        else {
          const at = r.finished.indexOf(partnerOf(head));
          possible = at >= 0 ? at + 1 === partnerPlace : partnerPlace > r.finished.length;
        }
      }
      out.push({ team, partnerPlace, steps, from, to: Math.min(target, from + steps), passA, possible });
    }
  }
  return out;
}

/** 每一副的记录：打几、游数、谁升了几级（战绩金榜与算分面板共用）。 */
export function roundHistory(m: Match): { no: number; playing: number; order: number[]; winnerTeam: 0 | 1; steps: number; passedA: boolean }[] {
  let lv: [number, number] = [2, 2];
  let playing = 2;
  return m.results.map((res, i) => {
    const row = { no: i + 1, playing, order: res.order, winnerTeam: res.winnerTeam, steps: res.steps, passedA: res.passedA };
    if (!res.passedA) lv = lv.map((v, t) => (t === res.winnerTeam ? Math.min(m.rules.target ?? 14, v + res.steps) : v)) as [number, number];
    playing = lv[res.winnerTeam];
    return row;
  });
}
